export function formatOpenGraph (opengraph) {
  const returnData = Object.keys(opengraph)
    .map(key => {
      return {
        key,
        property: key,
        content: opengraph[key]
      }
    })

  return returnData
}

export function formatCanonical (data, append, hrefs) {
  const hreflangs = hrefs || Object.entries(data.tags.hreflang)
  const returnData = []
  returnData.push({
    key: 'canonical',
    rel: 'canonical',
    href: data.tags.canonical + (append ? `/${append}` : '')
  })

  hreflangs.forEach(tag => {
    returnData.push({
      key: `alternate-${tag[0]}`,
      rel: 'alternate',
      hreflang: tag[0],
      href: tag[1] + (append && !hrefs ? `/${append}` : '')
    })
  })
  return returnData
}

export function formatHomeCanonical (selected, languages) {
  const returnData = []
  returnData.push({
    key: 'canonical',
    rel: 'canonical',
    href: 'https://www.gutsgusto.com/' + selected
  })
  languages.forEach(row => {
    if (row === selected) { return }
    returnData.push({
      key: 'alternate-' + row,
      name: 'alternate',
      href: 'https://www.gutsgusto.com/' + row,
      hreflang: row
    })
  })
  return returnData
}

export function getSchemaOrgOrganization (lang) {
  const config = useRuntimeConfig()
  return {
    '@type': 'Organization',
    '@id': 'https://www.gutsgusto.com#Organization',
    name: 'Guts & Gusto',
    alternateName: 'GUTSGUSTO.COM',
    url: 'https://www.gutsgusto.com',
    telephone: lang === 'de' ? '+49 39292 678217' : '+31 85 401 65 10',
    email: lang === 'de' ? 'service@gutsgusto.de' : 'info@gutsgusto.com',
    description: getDescription(lang),
    sameAs: [
      'https://www.facebook.com/GutsGusto',
      'https://www.youtube.com/gutsgustocom',
      'https://www.instagram.com/gutsgusto/',
      'https://www.kiyoh.com/reviews/1046162/gutsgusto_com?lang=' + lang,
      'https://www.pinterest.com/gutsgusto/',
      'https://www.tiktok.com/@gutsgusto',
      'https://www.linkedin.com/company/guts-&-gusto'
    ],
    logo: {
      '@type': 'ImageObject',
      url: `${config.public.cdnURL}assets/images/opengraph/name-logo.png`,
      width: 500,
      height: 500
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '9.2',
      bestRating: '10',
      worstRating: '1',
      reviewCount: '5187',
      url: 'https://www.kiyoh.com/reviews/1046162/gutsgusto_com?lang=nl'
    }
  }
}

export function getDescription (lang) {
  if (lang === 'de') {
    return 'Guts & Gusto, der Fashion Onlineshop mit den allertollsten Modeartikeln, die in keinem Kleiderschrank fehlen dürfen! Entdecke die schönsten Items für deinen perfekten Look.'
  }
  if (lang === 'nl') {
    return 'Kleding, schoenen en accessoires. Van festival looks tot een complete outfit. Shop online en in onze winkels. Voor 21.30 uur besteld = morgen in huis.'
  }
  return 'Clothing, shoes and accessoires. Festival vibes or complete classy outfits. Shop online and at our stores. Ordered before 21:30 = delivered tomorrow.'
}

export function formatHomeSchemaOrg (lang) {
  const config = useRuntimeConfig()
  if (lang === 'en') {
    return {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      url: 'https://www.gutsgusto.com/en',
      description: getDescription(lang),
      name: 'Guts & Gusto',
      inLanguage: 'en-GB',
      image: [`${config.public.cdnURL}assets/images/opengraph/general.jpg`],
      publisher: getSchemaOrgOrganization(lang)
    }
  }
  if (lang === 'de') {
    return {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      url: 'https://www.gutsgusto.com/de',
      description: getDescription(lang),
      name: 'Guts & Gusto',
      alternateName: 'GUTSGUSTO.COM',
      inLanguage: 'de-DE',
      image: [`${config.public.cdnURL}assets/images/opengraph/general.jpg`],
      publisher: getSchemaOrgOrganization(lang)
    }
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: 'https://www.gutsgusto.com/nl',
    description: getDescription(lang),
    name: 'Guts & Gusto',
    alternateName: 'GUTSGUSTO.COM',
    inLanguage: 'nl-NL',
    image: [`${config.public.cdnURL}assets/images/opengraph/general.jpg`],
    publisher: getSchemaOrgOrganization(lang)
  }
}

export function formatMetaDescription (data) {
  return {
    key: 'description',
    name: 'description',
    content: data.metaDescription
  }
}

export function appendSchemaOrgBreadcrumbList (schemaOrg, name, item) {
  const foundList = schemaOrg.find(item => item['@type'] === 'BreadcrumbList')

  if (!foundList) {
    return schemaOrg
  }

  const breadcrumbItemExists = foundList.itemListElement.find(breadcrumbItem => breadcrumbItem.item === item)
  if (breadcrumbItemExists) {
    return schemaOrg
  }

  foundList.itemListElement.push({
    '@type': 'ListItem',
    position: foundList.itemListElement.length + 1,
    name,
    item
  })

  return schemaOrg
}
